module.exports = __webpack_public_path__ + "img/play.2e94e305.png";